module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABVUlEQVRIS+2UsUpDQRBF731NQPADrLRRUBEbLdVG0HyCiFrIzoLw7Kxs7exMITuLhYr4CTFgFUstBFFBG638gICQ5o08SERMFIKmCdlyZ/fOncNliC4edlEbffG2dHsUi4hMkVwHMG9mowAGAdRIPgOomtmJqt79lLi2WERkAEAJwIaZXSVJcgHggWTNzPIGE1mWLZOcA3AMIFXV9+9N2onTe182s2GSayGEm/yTc26MZD5BNcb4lN9572fM7JTkawihCMC+NmgRd84VSZ4DGFfVt4bwZJIk12b2QnIky7LZGON9XhORIQCPZrYSYyz/Ki4iOwAWVXWp+dA5t0ByWlUPRGSb5G0Iodqsi0gFwKWq7nfs3Hu/aWa7JLfM7JDkXgjhqGPnAFqYp2laqNfrZwDyaSqFQmG1VCrVO2becNO1tHxi60rO/2sN9+hu+SuePpa2BD8AZc65GF7uwYkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chakan.png
// module id = evSc
// module chunks = 410